import { t } from "@lingui/core/macro";
import { RegrelloTypography } from "@regrello/ui-core";

export function Success() {
  return (
    <div className="flex flex-col items-center justify-center mt-10 gap-10">
      <RegrelloTypography variant="h1">{t`Success`}</RegrelloTypography>
      <p className="text-base text-center">
        {t`Your document has been successfully downloaded.`}
        <br />
        {t`You may now close this window.`}
      </p>
    </div>
  );
}
